/**
 * Helpers Functions
 */
import moment from 'moment';
import { store } from '@/store/store';

// Get moment object of Java Serialized LocalDateTime String
const getDateTimeObject = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z');
};

// 사용중
const printTimeStamp2 = (hhmmss) => {
  if (typeof hhmmss === 'object') {
    hhmmss = `${printTimeElement(hhmmss.hour)}${printTimeElement(hhmmss.minute)}${printTimeElement(hhmmss.second)}`;
  }
  return moment(`${hhmmss} +0000`, 'HHmmss Z').format('HH:mm');
};

// 위에서 사용중
const printTimeElement = (timeNum) => {
  return timeNum > 9 ? timeNum : `0${timeNum}`;
};

// 사용중
const printTimeStampFromDateTimeWithoutAP = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('HH:mm:ss');
};

// 사용중
const printTimeStampYYYYMMDDFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD');
};

// 사용중
const printTimeStampYYYYMMDDHHmmssFromUTCToKSTDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').add(9, 'hours').format('YYYY-MM-DD HH:mm:ss');
};

// 사용중
const printTimeStampHHmmFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').format('HH:mm');
};

// 사용중
const printTimeStampYYYMMDDHHmmADateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD HH:mm A');
};

// 사용중
const convertDateTimeToYYYYMMDDwithHyphen = (yyyyMMddhhmmss) => {
  let formatTime = 'YYYY-MM-DD';
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime);
};

// 사용중
const convertDateTimeToYYYYMMDDwithDot = (yyyyMMddhhmmss) => {
  let formatTime = 'YYYY.MM.DD';
  return moment(`${yyyyMMddhhmmss} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime);
};

// 사용중
const convertCreateDateToYYYY = (dateTime) => {
  let formatTime = 'YYYY-MM-DD HH:mm';
  return moment(`${dateTime} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime);
};

// 사용중
const convertCreateDateToYYYYMMDDhhmmss = (dateTime) => {
  let formatTime = 'YYYY-MM-DD HH:mm:ss';
  return moment(`${dateTime}`, 'YYYYMMDDHHmmss Z').format(formatTime);
};

// 사용중
const convertDateYyyyMmDd = (dateTime) => {
  let formatTime = 'YYYY-MM-DD';
  if (isNaN(dateTime)) {
    return dateTime;
  }
  return moment(dateTime, 'YYYYMMDD').format(formatTime);
};

const convertSecondsToHHMMSS = (secondStr) => {
  let seconds = Number(secondStr);
  return new Date(seconds * 1000).toISOString().substr(11, 8);
};

// 사용중
const print1DayToNow = () => {
  const day1 = moment().date(1).format('YYYY-MM-DD');
  const today = moment().format('MM-DD');

  return `${day1} ~ ${today}`;
};

// 사용중
const getCurrentDateTimeAsFormatted = () => {
  return moment().format('YYYYMMDDHHmmss');
};

// 사용중
const compareDates = (before) => {
  return moment(before).isBefore(moment.now());
};

// 사용중
const getMinuteDifferenceWithCurrentTime = (YYYYMMDDHHmmss) => {
  return moment().diff(moment(`${YYYYMMDDHHmmss}`, 'YYYYMMDDHHmmss Z'), 'minutes');
};

// 사용중
const convertTimeToMomentType = (YYYYMMDDHHmmss) => {
  return moment(YYYYMMDDHHmmss, 'YYYYMMDDHHmmss');
};

// 사용중
const getDateDiff = (startDate, endDate) => {
  let diffTime = moment(endDate, 'YYYY-MM-DD').diff(moment(startDate, 'YYYY-MM-DD'));
  let duration = moment.duration(diffTime);
  return Math.floor(duration.asDays());
};
/**
 * Text Truncate
 */
const textTruncate = (str, length, ending) => {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

const numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Function to return currenr app layout
 */
const getCurrentAppLayout = (router) => {
  let location = router.history.current.fullPath;
  let path = location.split('/');
  return path[1];
};

const findByChatRoomId = (chatRoomList, chatRoomId) => {
  return chatRoomList.find((room) => room.chatRoomId === chatRoomId);
};

const findTreeNodeByCode = (element, code) => {
  if (element.data.code === code) {
    return element;
  } else if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = findTreeNodeByCode(element.children[i], code);
    }
    return result;
  }
  return undefined;
};
// 노드 상태 가져오기
const getNodeStates = (element) => {
  let statesArray = [];
  pushStates(element, statesArray);
  return statesArray;
};
const pushStates = (element, array) => {
  let code = element.data.code;
  let states = element.states;
  array.push({ code: code, states: states });

  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = pushStates(element.children[i], array);
    }
    return result;
  }
  return undefined;
};

// 노드 상태 적용하기
const setNodeStates = (element, statesArray) => {
  statesArray.forEach((item) => {
    if (element.data.code === item.code) {
      element.states.expanded = item.states.expanded;
    }
  });

  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = setNodeStates(element.children[i], statesArray);
    }
    return result;
  }
  return undefined;
};

// 템플릿별 validation 체크
const validationTemplate = (element) => {
  if (element.data) {
    if (element.data.scenarioTemplateType === 'IMAGE') {
      let imageContent = element.data.imageContent;
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data);
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_TEXT') {
      let imageContent = element.data.imageContent;
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data);
      }
      let textContent = element.data.textContent;
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data);
      }
    } else if (element.data.scenarioTemplateType === 'LIST') {
      let listTemplates = element.data.listTemplates;
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data);
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_LIST') {
      let imageContent = element.data.imageContent;
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data);
      }
      let listTemplates = element.data.listTemplates;
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data);
      }
    } else if (element.data.scenarioTemplateType === 'IMAGE_LIST_TEXT') {
      let imageContent = element.data.imageContent;
      if (imageContent === undefined || imageContent.url.length === 0) {
        return returnData(element.data);
      }
      let listTemplates = element.data.listTemplates;
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data);
      }
      let textContent = element.data.textContent;
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data);
      }
    } else if (element.data.scenarioTemplateType === 'LIST_TEXT') {
      let listTemplates = element.data.listTemplates;
      if (!listTemplates || listTemplates.length === 0) {
        return returnData(element.data);
      }
      let textContent = element.data.textContent;
      if (textContent === undefined || textContent.title.length === 0 || textContent.description.length === 0) {
        return returnData(element.data);
      }
    }
  }

  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      // 시나리오 이동 외 다른 버튼 (URL, TEL, 상담원연결 등) 은 템플릿 validate 체크를 하지 않는다.
      if (element.children[i].data.templateType === 'LINK_BUTTON') {
        result = validationTemplate(element.children[i]);
      }
    }
    return result;
  }
  return undefined;
};

const returnData = (data) => {
  let result = {};
  // result['text'] = data.text
  result['code'] = data.code;
  result['template'] = data.scenarioTemplateType;
  return result;
};

const findByKey = (list, key) => {
  return list.find((room) => room.key === key);
};
const getLastItem = (list) => {
  if (list.length > 0) {
    return list[list.length - 1];
  }
  return undefined;
};

const longTextLengthAdjust = (message, length) => {
  return message !== undefined && message.length > length ? message.substring(0, length) + '...' : message || '';
};

const isObjectValid = (targetObject) => {
  return targetObject !== undefined && targetObject !== null && typeof targetObject === 'object';
};
const isObjectNotEmpty = (targetObject) => {
  return targetObject !== undefined && targetObject !== null && Object.keys(targetObject).length > 0 && typeof targetObject === 'object';
};

const getFileType = (file) => {
  if (file.type.includes('image/')) {
    return 'PHOTO';
  } else if (file.type.includes('video/')) {
    return 'VIDEO';
  }
  return null;
};

const removeChildNodes = (children) => {
  for (let index = 0; index < children.length; index++) {
    let child = children[index];
    child.data.scenarioFlowStatus = 'DELETED';
    if (child.children.length > 0) {
      removeChildNodes(child.children);
    }
  }
};

// 시나리오 변경 여부
const isScenarioContentChanged = (element) => {
  if (element.data.scenarioFlowStatus === 'CHANGED') {
    return element;
  }

  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = isScenarioContentChanged(element.children[i]);
    }
    return result;
  }
  return undefined;
};

const isStringValid = (str) => {
  return str !== undefined && str !== null && str.length > 0;
};

const isEmailValid = (email) => {
  let rule = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return rule.test(email);
};

const reduceText = (text, maxLength) => {
  return text.substring(0, maxLength).concat('...');
};

const reduceFileName = (fileName, maxLength) => {
  // 확장자가 없는 경우
  if (!fileName.includes('.')) {
    return reduceText(fileName, maxLength);
  }

  let fileExtension = fileName.split('.').pop();
  let reducedLength = maxLength - fileExtension.length + 2;
  if (fileName.length > reducedLength) {
    let reducedText = reduceText(fileName, reducedLength);
    return reducedText.concat(fileExtension);
  }
  return fileName;
};

const editExtensionRemove = (fileName) => {
  // 에디터에서 붙는 확장자들
  let extensions = ['vnd', 'msword', 'plain', 'mpeg', 'x', 'related', 'quicktime'];
  // 만약 위의 확장자들이 아닐경우 3gp 사용시 붙는 확장자를 기본으로 사용
  let eiditExtension = '3gpp';

  extensions.forEach((e) => {
    if (fileName.endsWith(e)) {
      eiditExtension = e;
      return false;
    }
  });

  return fileName.replace('.' + eiditExtension, '');
};

const charByteSize = (ch) => {
  if (ch == null || ch.length === 0) {
    return 0;
  }

  var charCode = ch.charCodeAt(0);

  if (charCode <= 0x00007f) {
    return 1;
  } else if (charCode <= 0x0007ff) {
    return 2;
  } else if (charCode <= 0x00ffff) {
    return 2;
  } else {
    return 4;
  }
};

const reduceByLength = (text, maxLength) => {
  return text.substring(0, maxLength);
};

const cutByLen = (str, maxByte) => {
  let b = 0;
  let i = 0;
  let c = 1;
  for (i = 0; c !== 0; ) {
    b += c >> 7 ? 2 : 1;
    if (b > maxByte) {
      break;
    }
    c = str.charCodeAt(i++);
  }
  return str.substring(0, i);
};

const getByteLength = (s) => {
  if (s == null || s.length === 0) {
    return 0;
  }
  var size = 0;

  for (var i = 0; i < s.length; i++) {
    size += charByteSize(s.charAt(i));
  }

  return size;
};

const textXssFilter = (inputTxt) => {
  // HTML태그 / eval( / document. / javascript: 제거
  return inputTxt
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/eval\(/gi, '')
    .replace(/document\./gi, '')
    .replace(/javascript:/gi, '');
};

const isSurveyContentChanged = (element) => {
  console.log(element);
  if (element.surveyContentsStatus === 'CHANGED') {
    return element;
  }
  return undefined;
};

// 카테고리 트리화
const initCategoryElements = (elements) => {
  let data = [];
  elements.forEach((e) => {
    let node = initCategory(e, data, null);
    if (node) {
      data.push(node);
    }
  });
  // TODO 자식노드까지 data array 에 담기므로.. 우선 parentCode 가 없는 것들만 리턴하도록하고 추후 로직 확인할 것.
  return data.filter((d) => !d.data.parentCode);
};
const initCategory = (element, array, parentCode) => {
  let code = getUUID();
  if (parentCode) {
    element['data'] = {
      categoryId: element.id,
      status: 'ORIGINAL',
      code: code,
      parentCode: parentCode,
      categoryDescription: element.categoryDescription
    };
  } else {
    element['data'] = { categoryId: element.id, status: 'ORIGINAL', code: code, categoryDescription: element.categoryDescription };
  }
  array.push(element);

  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = initCategory(element.children[i], array, code);
    }
    return result;
  }
  return undefined;
};

const checkOutofRoute = (targetNode, nodes) => {
  let result;
  for (let i = 0; i < nodes.length; i++) {
    // 하위에서 최상위로 나온 경우 제한.
    if (nodes[i].data.parentCode) {
      return false;
    }
    result = outofRoute(targetNode, nodes[i]);
    if (result === false) break;
  }
  return result;
};

const outofRoute = (targetNode, element) => {
  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      let childNode = element.children[i];
      if (targetNode.data.code === childNode.data.code) {
        if (targetNode.data.parentCode !== element.data.code) {
          result = false;
          return result;
        }
      }
      result = outofRoute(targetNode, element.children[i]);
    }
    return result;
  }
  return undefined;
};

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = (Math.random() * 16) | 0;
    let v = c === 'x' ? r : (r & 3) | 8;
    return v.toString(16);
  });
};

// 삭제되지 않은 카테고리 목록
const findTreeNotDeleted = (treeNodes) => {
  return treeNodes.filter(function f(node) {
    if (node.data.status !== 'DELETED') return true;
    if (node.children) {
      return (node.children = node.children.filter(f)).length;
    }
  });
};

const deleteWithChildNodes = (element) => {
  element.data.status = 'DELETED';
  if (element.children.length > 0) {
    let result;
    for (let i = 0; result === undefined && i < element.children.length; i++) {
      result = deleteWithChildNodes(element.children[i]);
    }
    return result;
  }
  return undefined;
};

const setCategoryName = (node) => {
  let la = node.text;
  let result = categoryName(node, la);
  return result;
};

const categoryName = (node, name) => {
  let result;
  if (node.parent !== null) {
    result = node.parent.text + '>' + name;
    return categoryName(node.parent, result);
  }
  if (node.parent === null) {
    return name;
  }
};
const findTreeModelByCode = (element, code) => {
  if (element.data.code === code) {
    return element;
  } else if (element.children.length > 0) {
    let result = '';
    for (let i = 0; i < element.children.length; i++) {
      if (!result) {
        result = findTreeNodeByCode(element.children[i], code);
      }
    }
    return result;
  }
  return undefined;
};

const outCommingPhoneCovert = (phone) => {
  const number = phone.replaceAll('-', '');

  // 네오메카 webRTC 버전은 전화번호 앞에 '9'를 붙이지 않는다.
  // 없는 국번으로 인식하기 때문.
  if (store.getters.isNeoWebRtc) {
    return number;
  }

  if (number.substr(0, 1) === '9') {
    return number;
  } else {
    return '9' + number;
  }
};

const inCommingPhoneCovert = (phone) => {
  const number = phone.replaceAll('-', '');

  if (number.substr(0, 1) === '9') {
    return number.substr(1);
  } else {
    return number;
  }
};

const isNumberic = (str) => {
  return !isNaN(Number(str));
};

const cutByteLength = (s, len) => {
  if (s === null || s.length === 0) {
    return 0;
  }
  let size = 0;
  let rIndex = s.length;
  for (let i = 0; i < s.length; i++) {
    size += charByteSize(s.charAt(i));
    if (size === len) {
      rIndex = i + 1;
      break;
    } else if (size > len) {
      rIndex = i;
      break;
    }
  }
  return s.substring(0, rIndex);
};

const parsingCallAgentStatus = (val) => {
  let byteData = [];
  let copyVal = val.slice();
  while (copyVal.length > 0) {
    byteData.push(cutByteLength(copyVal, 27));
    copyVal = copyVal.substr(byteData[byteData.length - 1].length);
    if (copyVal.length === 0) break;
  }

  let agentList = [];
  byteData.forEach((item) => {
    let status = item.substr(item.length - 3, 3).split('');
    if (status[0] === 'W' && status[1] === 'W') {
      let telNumber = item.substr(0, 4);
      let agentId = item.substr(4, item.length - 7).trim();
      agentList.push({ id: agentId, name: agentId, workingStatus: '대기', telNumber: telNumber });
    }
  });

  return agentList;
};

const parseNeoWebRtcAgentStatus = (val) => {
  let agentArr = [];

  val.forEach((agent) => {
    if (agent.AGENT_STATE === 'W' && agent.CALL_STATE === 'W') {
      agentArr.push({
        id: agent.AGENT_NAME,
        name: agent.AGENT_NAME,
        workingStatus: '대기',
        telNumber: agent.LINE_NO,
        sort: 1
      });
    } else if (agent.AGENT_STATE === 'S' && agent.CALL_STATE === 'W') {
      agentArr.push({
        id: agent.AGENT_NAME,
        name: agent.AGENT_NAME,
        workingStatus: '후처리',
        telNumber: agent.LINE_NO,
        sort: 3
      });
    } else if (
      agent.CALL_STATE === 'I' ||
      agent.CALL_STATE === 'O' ||
      agent.CALL_STATE === 'D' ||
      agent.CALL_STATE === 'E' ||
      agent.CALL_STATE === 'H' ||
      agent.CALL_STATE === 'R' ||
      agent.CALL_STATE === 'T' ||
      agent.CALL_STATE === 'C'
    ) {
      agentArr.push({
        id: agent.AGENT_NAME,
        name: agent.AGENT_NAME,
        workingStatus: '통화중',
        telNumber: agent.LINE_NO,
        sort: 2
      });
    }
  });
  return agentArr.sort((a, b) => a.sort - b.sort);
};

const parsingCallAgentAllStatus = (val) => {
  let byteData = [];
  let copyVal = val.slice();
  while (copyVal.length > 0) {
    byteData.push(cutByteLength(copyVal, 27));
    copyVal = copyVal.substr(byteData[byteData.length - 1].length);
    if (copyVal.length === 0) break;
  }

  let agentList = [];
  byteData.forEach((item) => {
    let status = item.substr(item.length - 3, 3).split('');
    if (status[0] === 'W' && status[1] === 'W') {
      let telNumber = item.substr(0, 4);
      let agentId = item.substr(4, item.length - 7).trim();
      agentList.push({ id: agentId, name: agentId, workingStatus: '대기', telNumber: telNumber, sort: 1 });
    } else if (status[0] === 'W' && status[1] === 'S') {
      let telNumber = item.substr(0, 4);
      let agentId = item.substr(4, item.length - 7).trim();
      agentList.push({ id: agentId, name: agentId, workingStatus: '후처리', telNumber: telNumber, sort: 3 });
    } else if (
      status[0] === 'I' ||
      status[0] === 'O' ||
      status[0] === 'D' ||
      status[0] === 'E' ||
      status[0] === 'H' ||
      status[0] === 'R' ||
      status[0] === 'T' ||
      status[0] === 'C'
    ) {
      let telNumber = item.substr(0, 4);
      let agentId = item.substr(4, item.length - 7).trim();
      agentList.push({ id: agentId, name: agentId, workingStatus: '통화중', telNumber: telNumber, sort: 2 });
    }
  });

  return agentList.sort((a, b) => a.sort - b.sort);
};

const phoneRegExp = (num) => {
  if (num) {
    let startNum = num.substring(0, 2);
    if (startNum === '15' || startNum === '16' || startNum === '18') {
      startNum = num.replace(/(^15.{2}|^16.{2}|^18.{2})([0-9]{4})/, '$1-$2');
    } else {
      startNum = num.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
    }
    return startNum;
  } else {
    return '';
  }
};
const printDashboardCount = (count) => {
  return count !== 0 ? count + '건' : '-';
};

const checkPassword = (pw, pwCon) => {
  if (!pw || !pwCon) {
    alert('비밀번호 및 비밀번호 확인을 모두 입력해주세요.');
    return false;
  }

  // 비밀번호 정규식 패턴
  let pwRex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}/g;
  let password = pw.replace(/(\s*)/g, '');
  let passwordConfirm = pwCon.replace(/(\s*)/g, '');

  if (!password || password.length < 1 || !passwordConfirm || passwordConfirm.length < 1) {
    alert('비밀번호 및 비밀번호 확인을 모두 입력해주세요.');
    return false;
  } else if (password !== passwordConfirm) {
    alert('비밀번호를 다르게 입력하였습니다.');
    return false;
  } else if (!pwRex.test(password)) {
    alert('비밀번호는 영문 대소문자/숫자/특수문자 모두 사용하여 8~16자리로 입력해주세요.');
    return false;
  }
  return true;
};
const freezeOff = (object) => {
  return JSON.parse(JSON.stringify(object));
};

const findCallApiUrl = (type) => {
  let url = null;
  if (type) {
    url = process.env.CALL_API_URL[type];
  }
  return url;
};

const findCallUrl = (type) => {
  let url = null;
  switch (type) {
    case 'NEOMECCA_1':
      url = process.env.CALL_URL;
      break;
    case 'NEOMECCA_2':
      url = process.env.CALL_URL_2;
      break;
    case 'NEOMECCA_3':
      url = process.env.CALL_URL_3;
      break;
    case 'NEO_WEB_RTC_1':
      url = process.env.CALL_WEB_RTC_URL;
  }
  return url;
};

const findCallWebsocketUrl = (type) => {
  let url = null;
  if (type) {
    url = process.env.CTI_WEBSOCKET_URL[type];
  }
  return url;
};

const findCallStatusUrl = () => {
  let url = process.env.CALL_STATUS_URL || null;
  return url;
};

const getCategoryNavigation = (node, newName = '새 카테고리') => {
  if (!node) {
    return '';
  }
  let name = node.data.isNew && !node.data.name ? newName : node.data.name;
  let result = getParentCategoryNavigation(node, name, newName);
  return result;
};

const getParentCategoryNavigation = (node, name, newName) => {
  if (!node) {
    return '';
  }
  let result;
  if (node.parent) {
    result = node.parent.data.isNew && !node.parent.data.name ? `${newName}>${name}` : `${node.parent.data.name}>${name}`;
    return getParentCategoryNavigation(node.parent, result, newName);
  }
  if (!node.parent) {
    return name;
  }
};

const stringifyData = (data, error = 'PARSING ERROR') => {
  let result = '';
  try {
    result = JSON.stringify(data);
  } catch (err) {
    result = error;
  }
  return result;
};

const setLocalStorageAgentAuthorityBrandInfoValueByIdAndKey = (payload) => {
  const { key, brandId, value } = payload;
  let agentAuthority = JSON.parse(localStorage.getItem('agent-authority'));
  let brandInfos = agentAuthority.brandInfos;

  const brandIdList = brandInfos.map((brand) => brand.id);
  const brandIndex = brandIdList.indexOf(brandId);
  brandInfos[brandIndex][key] = value;
  agentAuthority.brandInfos = brandInfos;
  localStorage.setItem('agent-authority', JSON.stringify(agentAuthority));
};

const twoDepthArrayFromArray = (array = [], maxLength = 0) => {
  if (!array.length || !maxLength) {
    return [];
  }
  const result = [];
  for (let i = 0; i < array.length; i += maxLength) {
    result.push(array.slice(i, i + maxLength));
  }
  return result;
};

const DynamicSizeTwoDepthArrayFromArray = (array = [], sizeArray = []) => {
  // 2차원 배열을 만들되, 내부 배열의 크기가 동적으로 다른 경우에 사용하는 함수
  if (!array.length || !sizeArray.length) {
    return [];
  }
  const result = [];
  let index = 0;

  for (let i = 0; i < sizeArray.length && index < array.length; i++) {
    const size = sizeArray[i];
    if (size <= 0) continue; // 0 이하 값은 무시
    result.push(array.slice(index, index + size));
    index += size;
  }

  // 남은 원소는 몰아넣기
  if (index < array.length) {
    result.push(array.slice(index));
  }

  return result;
};

const buildSizeArray = (fields = [], maxCols = 4, maxThPerRow = 2) => {
  // 2차원 배열에서, 내부 배열의 크기를 설정하기 위한 함수
  // DynamicSizeTwoDepthArrayFromArray 함수와 함께 사용하며,
  // 본 함수의 return 값이 [2, 1, 3] 이라면,
  // DynamicSizeTwoDepthArrayFromArray 함수에 본 함수의 return값을 파라미터로 전달하여
  // [{}, {}], [{}], [{}, {}, {}] 형태의 2차원 배열을 만들 수 있음.

  const depthArray = [];
  let usedCols = 0;
  let usedTh = 0;
  let countInRow = 0;

  const flushRow = () => {
    if (countInRow > 0) depthArray.push(countInRow);
    usedCols = 0;
    usedTh = 0;
    countInRow = 0;
  };

  for (const item of fields) {
    const rawTdSpan = Number(item) || 1;
    const tdSpan = Math.max(1, Math.min(rawTdSpan, maxCols - 1));
    const needCols = 1 + tdSpan; // th 1 + td tdSpan

    const exceedCols = usedCols + needCols > maxCols;
    const exceedTh = usedTh + 1 > maxThPerRow;

    if (countInRow > 0 && (exceedCols || exceedTh)) {
      flushRow(); // 줄바꿈
    }

    // 현재 줄에 배치
    usedCols += needCols;
    usedTh += 1;
    countInRow += 1;
  }

  flushRow(); // 마지막 줄 반영
  return depthArray;
};
const getImageUrl = (urlPath) => {
  // 다음 axz용 도메인과 일반 aws 도메인 분리
  const isAXZ = store.getters.isWorkplaceUsingCustomOption('AXZ');
  let domain = '';
  if (isAXZ) {
    domain = 'https://s3-bucket-pri.thecloudgate.io/public-common-sdk';
  } else {
    domain = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com';
  }
  return domain + urlPath;
};

export default {
  getDateTimeObject,
  printTimeStampFromDateTimeWithoutAP,
  printTimeStampYYYYMMDDFromDateTime,
  printTimeStampYYYYMMDDHHmmssFromUTCToKSTDateTime,
  printTimeStampHHmmFromDateTime,
  printTimeStampYYYMMDDHHmmADateTime,
  convertDateTimeToYYYYMMDDwithHyphen,
  convertDateTimeToYYYYMMDDwithDot,
  convertCreateDateToYYYY,
  convertCreateDateToYYYYMMDDhhmmss,
  convertDateYyyyMmDd,
  convertSecondsToHHMMSS,
  print1DayToNow,
  getMinuteDifferenceWithCurrentTime,
  numberWithCommas,
  textTruncate,
  getCurrentAppLayout,
  printTimeStamp2,
  findByChatRoomId,
  findByKey,
  getLastItem,
  longTextLengthAdjust,
  isObjectValid,
  isObjectNotEmpty,
  isStringValid,
  isEmailValid,
  getFileType,
  getCurrentDateTimeAsFormatted,
  findTreeNodeByCode,
  validationTemplate,
  removeChildNodes,
  isScenarioContentChanged,
  compareDates,
  getNodeStates,
  setNodeStates,
  convertTimeToMomentType,
  reduceText,
  reduceByLength,
  reduceFileName,
  charByteSize,
  cutByLen,
  getByteLength,
  textXssFilter,
  isSurveyContentChanged,
  initCategoryElements,
  findTreeNotDeleted,
  deleteWithChildNodes,
  outofRoute,
  checkOutofRoute,
  setCategoryName,
  findTreeModelByCode,
  editExtensionRemove,
  outCommingPhoneCovert,
  inCommingPhoneCovert,
  isNumberic,
  parsingCallAgentStatus,
  phoneRegExp,
  cutByteLength,
  parsingCallAgentAllStatus,
  parseNeoWebRtcAgentStatus,
  printDashboardCount,
  checkPassword,
  freezeOff,
  findCallApiUrl,
  findCallUrl,
  findCallWebsocketUrl,
  findCallStatusUrl,
  getDateDiff,
  getCategoryNavigation,
  stringifyData,
  setLocalStorageAgentAuthorityBrandInfoValueByIdAndKey,
  DynamicSizeTwoDepthArrayFromArray,
  twoDepthArrayFromArray,
  buildSizeArray,
  getImageUrl
};



// WEBPACK FOOTER //
// ./src/util/helpers.js